<template>
    <div id="calendar-container">
        <full-loading v-if="carregando"  key="something" theme="white" message="Carregando agenda..."></full-loading>
            <div class="fixed-action-btn" v-if="checaCargoUsuario([], [cargoGerente, cargoCorretor, cargoEspecialista, cargoLider])">
                <a class="btn-floating btn-large btn-default pulse btn-default">
                    <i class="large material-icons">add</i>
                </a>
                <ul>
                    <li>
                        <router-link to="/agenda/cadastro" class="btn-floating btn btn-default" v-tooltip.left="'Novo evento'">
                            <i class="material-icons">today</i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/cliente/cadastro" class="btn-floating btn btn-default" v-tooltip.left="'Novo cliente'">
                            <i class="material-icons">people</i>
                        </router-link>
                    </li>
                </ul>
            </div>

        <div class="col s12 m6 l2 p10" v-if="!carregando && funcionarios.length > 0 && checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista], [cargoMaster, cargoDono, cargoGerente, cargoEspecialista])">

                <div class="row">
                    <card title="Filtros"  id="subtitle">
                        <template slot="content">
                            <div class="row valign-wrapper mt-1" v-for="funcionario in funcionarios" :key="`funcionario-filtro-item-${funcionario.funcionario_id}`">
                                <div class="col m2">
                                    <div :class="'square '+corBotao(funcionario.funcionario_id)"></div>
                                </div>
                                <div class="col m11 pl-0">
                                    {{ funcionario.pessoa.pessoa_nome }}
                                </div>
                        </div>
                        </template>
                    </card>
                </div>
            <!-- </div> -->
        </div>
        <div class="col s12 m6 l8" v-show="!carregando" :class="!checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista], [cargoMaster, cargoDono, cargoGerente, cargoEspecialista])? ' m12 l12' : 'm6 l8'">
            <div class="card">

                <div id='calendar'></div>
            </div>
        </div>

        <div class="col s12 m6 l2 p10" v-if="checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista], [cargoMaster, cargoDono, cargoGerente, cargoEspecialista])">
             <card title="Filtros"  id="subtitle" v-if="!carregando" :showActions="showCardActionsFilter" @clearFilter="limparFiltros">
                <template slot="content"  v-if="!carregando">
                    <div class="row" v-if="checaCargoUsuario([cargoDono, cargoGerente, cargoEspecialista])">
                        <div class="col s12">
                        <div class="row">

                            <div class="Search">
                                <div class="col s12">
                                    <span class="Search__title grey-text">Por funcionário:</span>
                                </div>

                                 <div class="chip mt-3"
                                    v-for="func in funcionarios_selecionados"
                                    :key="`funcionario-selecionado-${func.funcionario_id}`">
                                    {{ func.pessoa_nome }}
                                    <i class="close material-icons" @click="removeFilterFuncionario(func.funcionario_id)">close</i>
                                </div>
                                <div class="Search input-field col s12 input-search" id="filter-calendar1">
                                    <i class="material-icons">person_outline</i>
                                    <input type="text" v-model="termo_funcionario" class="autocomplete">
                                    <i @click="() => termo_funcionario = ''" class="material-icons md-18 grey-text clear">clear</i>
                                    <label for="nome"></label>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>

                     <ul class="collection">
                        <li class="collection-item avatar"  v-for="funcionario in funcionarios_filtrados" :key="`funcionario-item-${funcionario.funcionario_id}`">

                            <i v-if="!funcionario.pessoa.pessoa_avatar" class="material-icons circle">person_outline</i>

                            <img v-if="funcionario.pessoa.pessoa_avatar" :src="funcionario.pessoa.pessoa_avatar" alt="" class="circle">
                            <span class="title">
                                {{ funcionario.pessoa.pessoa_nome }}</span>
                            <p>{{ funcionario.funcionario_cargo.funcionario_cargo_nome }}</p>
                            <div class="secondary-content">
                                <input
                                    type="checkbox"
                                    v-model="funcionario_ids"
                                    :value="funcionario.funcionario_id"
                                    :id="`funcionario${funcionario.funcionario_id}`" />
                                <label :for="`funcionario${funcionario.funcionario_id}`"></label>
                            </div>
                        </li>
                    </ul>
                    <ul class="collection collection-alone with-header" id="filter-calendar2">

                        <li class="collection-header pl-0">
                            <span class="Search__title grey-text pl-0">Por estado:</span>

                        </li>

                        <li class="collection-item dismissable pb-0" v-for="estado in estados" :key='`estado-item-${estado.nome}`'>
                            <input type="checkbox" v-model="estados_selecionados" :value="estado.valor" :id="`visita-${estado.nome}`" />
                            <label :for="`visita-${estado.nome}`"></label>
                            <span class="title title-alone">{{ estado.nome }}</span>
                        </li>
                    </ul>

                </template>
             </card>
        </div
        >
    </div>
</template>
<style>
    #calendar-container{
        position: relative;
    }
    .Search__title{
        text-transform: uppercase;
        font-size: .78rem;
        font-weight: normal;
    }
    .fc-toolbar{
        background-color: #f9f9f9;
    }
    #calendar th{
        border-style: solid;
        border-width: 1px;
        border-color: #ddd;
    }
    .fc-content-skeleton thead{
        border: 0;
    }
    th.fc-day-header.fc-widget-header{
        padding: 5px;
    }
    .fc-head .fc-widget-header{
        border-top: 0;
    }
    .square {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .fc-event-container{
        cursor: pointer;
    }
    .fc-event .fc-content{
        padding-top: 10px;
        height: 33px;
    }
    .fc-basic-view .fc-body .fc-row {
        min-height: 11em !important;
    }
    .fc-day-grid-event .fc-content {
        white-space: inherit !important;
     }
    .fc-button{
        background: #fff;
        box-shadow: none;
        border-radius: 0;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        margin: 0 1px !important;
        color: #2089ce !important;
        border: 0;
    }

    .fc-basic-view .fc-body .fc-row {
        min-height: 11em !important;
    }

    .fc-content{
        position: relative;
        color: #777777 !important;
        margin-left: 9px;
    }
    a.fc-event{
        border: 0;
    }
    a.fc-event:before{
        background-color: #f9f9f9;
        content: ' ';
        height: 100%;
        position: absolute;
        width: calc(100% - 2px);
        top: 0;
        right: -2px;
        z-index: 0;
    }
    a.fc-event:after{
        background-color: inherit;
        content: ' ';
        height: 100%;
        position: absolute;
        width: 2px;
        top: 0;
        left: -2px;
        z-index: 0;
    }
    .fc-today-button{
        margin-top: 11px !important;
    }
     .fc-button-group{
         margin-top: 11px;
         margin-right: 11px;
         margin-left: 11px !important;
     }
    .fc-day-grid-event .fc-content {
        white-space: nowrap;
    }
    .fc button{
        padding: 0 .8em;
    }
    #calendar h2{
        margin-top: 10px;
        text-transform: capitalize;
    }

</style>
<script>
import { api } from '@/helpers/api';
import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, MASTER } from '@/constants/funcionarioCargo.js';
import { CORES_AGENDA } from '@/constants/coresAgenda.js';
import Auth from '@/store/auth';
import Message from '@/helpers/message';

import FullLoading from '@/components/common/FullLoading';
import {
    ESTAGIO_CHAMADA_TELEFONICA,
    ESTAGIO_PRIMEIRA_VISITA,

} from '@/constants/pedidoEstagio.js';
import Card from '@/components/common/Card/Card';
import { checaCargo } from '@/helpers/perfil';

export default {

    data() {
        return {
            eventos: [],

            eventos_avulsos: [],

            funcionarios: [],

            funcionario_ids: [],

            estados: [
                {
                    nome: 'Visita',
                    valor: ESTAGIO_PRIMEIRA_VISITA,
                },
                {
                    nome: 'Contato',
                    valor: ESTAGIO_CHAMADA_TELEFONICA,
                }
            ],

            pesquisa: {
                data_ini: moment().startOf('month').subtract(10, "days").format("YYYY-MM-DD"),
                data_fim: moment().endOf('month').add(10, "days").format("YYYY-MM-DD"),
            },

            estados_selecionados: [],

            usuarioLogadoCargo:  Auth.getCargoUsuario(),
            cargoDono: DONO,
            cargoGerente: GERENTE,
            cargoCorretor: CORRETOR,
            cargoEspecialista: ESPECIALISTA,
            cargoLider: LIDER,
            cargoMaster: MASTER,
            selectUsuarioAgenda: '',
            termo_funcionario: '',
            carregando: true,
            showCardActionsFilter: true,

            actionCalendar: false,
        };

    },
    components: {
        Card,
        FullLoading
    },

    computed: {

        funcionarios_filtrados() {
            return this.funcionarios.filter(({pessoa: {pessoa_nome}}) => {
                return pessoa_nome.toLowerCase().includes(this.termo_funcionario.toLowerCase()) && this.termo_funcionario
            })
        },

        funcionarios_selecionados() {
            return this.funcionarios.filter(item => this.funcionario_ids.includes(item.funcionario_id));
        },

        eventos_filtrados() {

            return this.eventos.filter(this.filtrarEventos);
        },

        eventos_avulsos_filtrados() {

            return this.eventos_avulsos.filter(this.filtrarEventosAvulsos);
        },

        todos_eventos_filtrados() {
            return [...this.eventos_filtrados, ...this.eventos_avulsos_filtrados];
        }
    },
    mounted: function () {

        this.init();
    },
    methods: {

        filtrarEventos({funcionario_id, pedido_estagio_id})
        {

            const funcionario = this.funcionario_ids.length === 0
                                || this.funcionario_ids.includes(funcionario_id);

            const estado = this.estados_selecionados.includes(pedido_estagio_id)
                            || this.estados_selecionados.length === 0;

            return funcionario && estado;

        },
        filtrarEventosAvulsos ({funcionario_id, pedido_historico_id})
        {

            const funcionario = this.funcionario_ids.length === 0 || this.funcionario_ids.includes(funcionario_id);

            return funcionario;
        },

        async init() {

            const calendar = $('#calendar');

            calendar.fullCalendar({
                height: 1100,
                contentHeight: 1100,

                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,basicWeek,basicDay'
                },
                defaultDate: moment().format('YYYY/MM/DD'),
                start:  moment().format('YYYY/MM/DD'),
                end: moment().format('YYYY/MM/DD'),
                editable: false,
                droppable: true,
                eventLimit: true,

                eventRender: (event, el) => {

                    el.click( e => {

                        e.preventDefault();

                        if (event.agenda_id) {
                            this.$router.push('/agenda/' + event.agenda_id);
                        } else if (event.pedido_historico_id) {
                            this.$router.push('/agenda-sistema/' + event.pedido_historico_id);
                        }
                    });
                },
                eventDrop: (event, delta, revertFunc) => {

                    if (event.agenda_id) {
                        api.put('agenda/update-data/' + event.agenda_id, {
                            agenda_data: event.start.format('DD/MM/YYYY HH:mm')
                        });
                    } else if (event.pedido_historico_id) {
                        api.put('pedido-historico/update-data/' + event.pedido_historico_id, {
                            pedido_visita_data: event.start.format('DD/MM/YYYY HH:mm')
                        });
                    }
                },

                loading: (icarregando) => {
                    this.carregando = icarregando
                }

            }, true);


            const changeDate = async (view) => {

                // await this.$nextTick();

                let data_ini = view.intervalStart ? view.intervalStart.format() : undefined;
                let data_fim = view.intervalEnd ? view.intervalEnd.format() : undefined;

                // Quando é mês, seleciona 10 dias antes e depois
                // para poder preencher o restante dos dias do outro mês que aparece no outro calendário
                if (view.type == 'month') {
                    data_ini = moment(data_ini).subtract(10, "days").format("YYYY-MM-DD");
                    data_fim = moment(data_fim).add(10, "days").format("YYYY-MM-DD");
                }

                if (data_ini && data_fim) {
                    this.pesquisa = {data_ini, data_fim};
                }

                this.carregarDadosEventos();
            }

            $('.fc-button').click(() => {
                const view = calendar.fullCalendar('getView');
                changeDate(view)
            })

            this.carregarDadosEventos();


            if ($(window).width() <= 600) {

                await this.$nextTick();

                $('.fc-basicDay-button').click();
            }
        },

        async carregarDadosEventos()
        {

            const {data: {result: {data: dados}}} = await api.post('agenda/agenda-data', this.pesquisa);

            this.funcionarios = dados.funcionarios || [];

            let eventos = [];

            dados.eventos.forEach(({pedido_historico}) => {

                if (! pedido_historico.pedido) return;

                const {
                    pedido_visita_data,
                    pedido_visita_tipo,
                    funcionario,
                    pedido: {
                        cliente_has_produto: {
                            cliente
                        }
                    }
                } = pedido_historico;

                eventos.push({
                    title              : `- ${cliente.pessoa.pessoa_nome} - ${pedido_visita_tipo}`,
                    start              : pedido_visita_data,
                    className          : CORES_AGENDA[funcionario.funcionario_id],
                    funcionario_id     : funcionario.funcionario_id,
                    pedido_historico_id: pedido_historico.pedido_historico_id,
                    pedido_estagio_id:  pedido_historico.pedido_estagio_id,
                });

            });


            this.eventos = eventos;

            const eventos_avulsos = [];

            dados.eventosAvulsos.forEach((evento) => {

                if (evento.agenda_data_fim) {

                    let agenda_inicio = evento.agenda_data;
                    let agenda_fim    = evento.agenda_data_fim;

                    if (this.pesquisa.data_ini > agenda_inicio) {
                        agenda_inicio = this.pesquisa.data_ini;
                    }

                    if (agenda_fim > this.pesquisa.data_fim) {
                        agenda_fim = this.pesquisa.data_fim
                    }

                    const range = moment().range(agenda_inicio, evento.agenda_data_fim).by('days');

                    let count = 0;

                    for (let date of range) {

                        eventos_avulsos.push({
                            title: evento.agenda_nome,
                            start: date.format('YYYY-MM-DD'),
                            className: CORES_AGENDA[evento.funcionario.funcionario_id],
                            funcionario_id: evento.funcionario.funcionario_id,
                            agenda_id: evento.agenda_id,
                        });

                        if (++count > 40) break;
                    }


                } else {

                    eventos_avulsos.push({
                        title: evento.agenda_nome,
                        start: evento.agenda_data,

                        className: CORES_AGENDA[evento.funcionario.funcionario_id],
                        funcionario_id: evento.funcionario.funcionario_id,
                        agenda_id: evento.agenda_id,
                    });
                }

            });

            this.eventos_avulsos = eventos_avulsos;


            this.carregando = false;
        },

        limparFiltros() {

            this.estados_selecionados = [];
            this.funcionario_ids = [];
            this.termo_funcionario = '';
        },
        removeFilterFuncionario(id_funcionario){
            this.estados_selecionados = this.estados_selecionados.filter(checkFunc => checkFunc != id_funcionario);
        },
        checaCargoUsuario(cargoMono, cargoMulti){
            return checaCargo(cargoMono, cargoMulti)
        },
        corBotao(id) {
            return CORES_AGENDA[id];
        },
        showLoading () {
            this.$parent.$parent.$emit('showLoading', true);
        },
        hideLoading () {
            this.$parent.$parent.$emit('showLoading', false);
        },
    },
    watch: {

        todos_eventos_filtrados(eventos)
        {
            const calendar = $('#calendar');

            calendar.fullCalendar('removeEvents');
            calendar.fullCalendar('addEventSource', eventos);
            calendar.fullCalendar('refetchEvents');

            this.$nextTick(() => calendar.fullCalendar('render'))
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Calendar.vue